/* This is the EMIS Pre disable components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
      <HelpIcon :help="htext"/>
    </div>
    <div>
      <table
        style="height: 82px; width: 750px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr style="height: 31px">
            <td
              style="
                width: 270px;
                height: 56px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              បរិយាយ
            </td>
            <td
              style="
                width: 120px;
                height: 31px;
                text-align: center;
                vertical-align: middle;
              "
              colspan="2"
            >
              ថ្នាក់កម្រិតទាប
            </td>
            <td
              style="
                width: 120px;
                height: 31px;
                text-align: center;
                vertical-align: middle;
              "
              colspan="2"
            >
              ថ្នាក់កម្រិតមធ្យម
            </td>
            <td
              style="
                width: 120px;
                height: 31px;
                text-align: center;
                vertical-align: middle;
              "
              colspan="2"
            >
              ថ្នាក់កម្រិតខ្ពស់
            </td>
            <td
              style="
                width: 120px;
                height: 31px;
                text-align: center;
                vertical-align: middle;
              "
              colspan="2"
            >
              ថ្នាក់ចម្រុះ
            </td>
            <td
              style="
                width: 120px;
                height: 31px;
                text-align: center;
                vertical-align: middle;
              "
              colspan="2"
            >
              សរុប
            </td>
          </tr>
          <tr style="height: 25px">
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              សរុប
            </td>
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ស្រី
            </td>
            <td
              style="
                width: 60px;
                text-align: center;
                vertical-align: middle;
                height: 25px;
              "
            >
              សរុប
            </td>
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ស្រី
            </td>
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              សរុប
            </td>
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ស្រី
            </td>
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              សរុប
            </td>
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ស្រី
            </td>
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              សរុប
            </td>
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ស្រី
            </td>
          </tr>
          <tr
            v-for="(value, row) in disable.length"
            :key="row"
            style="height: 25px"
          >
            <td
              :class="[
                disable[row].val + 1 ? 'td-white-long' : 'td-light-long',
              ]"
            >
              {{ disable[row].text }}
            </td>
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[0]"
                class="number"
              />
            </td>
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[1]"
                class="number"
              />
            </td>
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[2]"
                class="number"
              />
            </td>
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[3]"
                class="number"
              />
            </td>
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[4]"
                class="number"
              />
            </td>
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[5]"
                class="number"
              />
            </td>
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[6]"
                class="number"
              />
            </td>
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[7]"
                class="number"
              />
            </td>
            <!-- Total col -->
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <div
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
              >
                {{ row1[disable[row].val] | blank }}
              </div>
            </td>
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <div
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
              >
                {{ row2[disable[row].val] | blank }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { disable } from "@/utils/ascf/commonConfig.js";

export default {
  props: ["data", "title", "htext"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      disable: disable,
    };
  },
  computed: {
    row1: function () {
      /*
			let d = 
      return d.reduce(function (acc, cval, ind, arr) {
        return (ind < s || ind % 2 === 0) ? acc : acc + cval
			}, 0)
			*/
      let result;
      let d = this.data;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 0) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    row2: function () {
      let result;
      let d = this.data;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 1) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "";
      return value;
    },
  },
};
</script>

<style scoped>
.td-white {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: white;
}
.td-light {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
.td-white-long {
  width: 250px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
  background-color: white;
}
.td-light-long {
  width: 250px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
  background-color: lightgray;
}
.number {
  width: 50px;
  text-align: center;
}
</style>